<footer class="footer mt-4">
  <div class="d-sm-flex justify-content-center justify-content-sm-between">
    <span class="text-muted text-center text-sm-left d-block d-sm-inline-block">Counter Guard from
      <a href="https://www.dolphio.hu/" target="_blank">Dolphio Technologies</a></span>
    <span class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">© Dolphio Technologies - Counter Guard - {{currentYear}}</span>
  </div>
</footer>
